/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import userApi from 'api/user.api';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';

export const editUserRoles = createFOAsyncThunk('user/editUserRoles', async ({ organizationId, userId, userRoles }) => {
  await userApi.editUserRoles(organizationId, userId, userRoles);
});
